import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ModalLoan from '../components/ModalLoan';  // Import the ModalLoan component
import styles from '../styles/pages/interest_rates_page.module.css'; // Import your custom styles
import { useAuth } from "../authentication/AuthContext";
function InterestRates() {
  const [rates, setRates] = useState([]); // State to hold interest rates
  const [loading, setLoading] = useState(true); // State for loading
  const [loadingInput, setLoadingInput] = useState(true);
  const [ratesInput, setRatesInput] = useState(null);
const { isAuthenticated } = useAuth();
  // Fetch interest rates from the backend API
  useEffect(() => {
    const fetchRates = async () => {
      try {
        const response = await axios.get('/api/depositeInterestRates');
        if (response.data && response.data.data) {
          setRates(response.data.data);  // Set the fetched data to rates
        }
      } catch (error) {
        console.error("Error fetching interest rates:", error);
      } finally {
        setLoading(false);
      }
    };

    const fetchRatesInput = async () => {
  try {
    const response = await axios.get('/api/depositeRateInput');
    console.log(response.data.content);
    if (response.data) {
      setRatesInput(response.data.content); // this is now an object
      
    }
  } catch (error) {
    console.error("Error fetching interest rates Input:", error);
  } finally {
    setLoadingInput(false);
  }
};
fetchRatesInput();
    fetchRates(); // Fetch rates on component mount
  }, []);
 const isLoading = loading || loadingInput;
  // Handle sending updated interest rates to the backend
  const postInterestRatesData = async (updatedRates) => {
    try {
      const response = await axios.post("/api/depositeInterestRates", updatedRates);

      if (response.data && response.data.message) {
        setRates(updatedRates);  // Update the state with the new rates
        alert("Interest rates updated successfully!");
      }
    } catch (error) {
      console.error("Error updating interest rates:", error);
      alert("Failed to update interest rates.");
    }
  };

  return (
    <div className="body">
      <div className="heading">DEPOSIT INTEREST RATES</div>
      <hr />
      <hr />
 <div className="body">
        <div style={{display:"flex", justifyContent: "space-evenly"}}>
       <p className={styles.wef}>{ratesInput}</p>

{isAuthenticated && (
  <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
    <input
      value={ratesInput}
      onChange={(e) => setRatesInput(e.target.value)}
      style={{ flex: 1 }}
    />
    <button onClick={async () => {
      try {
        await axios.post('/api/depositeRateInput', { content: ratesInput });
        alert("Content updated successfully!");
      } catch (err) {
        alert("Failed to update content.");
      }
    }}>
      Save
    </button>
  </div>
)}
      {/* Show the modal to edit interest rates */}
      {isAuthenticated  && (  
      <ModalLoan
        onSubmit={postInterestRatesData}  // Pass the submit function to the modal
        value={rates}  // Pass the existing rates to the modal
      />
      )}
      </div>
      </div>
      <div className="body">
        <div className={styles.table}>
          <div className={`${styles.head} ${styles.row}`}>
            <p className={styles.col1}>DEPOSIT PERIOD</p>
            <p className={styles.col2}>GENERAL DEPOSITORS</p>
            <p className={styles.col3}>SENIOR CITIZENS</p>
          </div>

          {/* Show loading message while data is being fetched */}
          {isLoading ? (
            <p>Loading...</p>
          ) : (
            // Show the rates once they are fetched
            rates.map((item, index) => (
              <div key={index} className={styles.row}>
                <p className={styles.col1}>{item.deposit_period}</p>
                <p className={styles.col2}>{item.general_depositors}%</p>
                <p className={styles.col3}>{item.senior_citizens}%</p>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

export default InterestRates;
